import { Component } from '@angular/core';
import { Globals } from '../common/globals';
import { CommonService } from '../common/services/common.service';
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
})
export class TermsConditionsComponent {

  constructor(
    protected globals: Globals,
    protected commonService: CommonService,
    private sanitizer: DomSanitizer
  ) { }

  isApplicationTandC = false;
  isFacilityPurchaseTandC = false;

  ngOnInit() {
    this.isApplicationTandC = this.globals.currentLinkArr[1] == 'application-terms-conditions';
    this.isFacilityPurchaseTandC = this.globals.currentLinkArr[2] == 'facility-purchase-terms-conditions';
    this.getContent();
  }

  content: any = "";

  getContent() {
    this.commonService.showLoader();
    this.commonService.getConfByKey(this.key).then(
      (data: any) => {
        this.content = data.data;
        this.commonService.hideLoader();
      },
      (error) => {
        this.commonService.hideLoader();
      }
    );
  }

  get key() {
    if (this.isApplicationTandC) {
      return 'APPLICATION_TERMS_AND_CONDITIONS';
    } else if (this.isFacilityPurchaseTandC) {
      return 'FACILITY_PURCHASE_TERMS_AND_CONDITIONS';
    }
    return '';
  }

  get htmlContent() {
    return this.sanitizer.bypassSecurityTrustHtml(this.content);
  }
}